import { ref, computed, inject } from "vue"
import { useAuth } from "../composition-api/useAuth"
import { setError, setSuccess } from "./Notification"
import { sortTimeEntries, ensureTransportEntryExtensions } from "../utils/timeEntryExtensions"
import { insertNewTransportEntryAsync, getEntityAsync } from "../api"

// split out of components/WorkOrderTransports.js, which is now a `.vue`: a `<script setup>` block
// runs per instance and cannot carry a module-level composable alongside the component
export const useTransportEntries = () => {
  const { fetchAuthAsync } = useAuth()

  const transportEntries = ref([])

  const getLocationAsync = inject("getLocationAsync")

  const loadTransportEntriesAsync = async (workOrderType, workOrderId) => {
    if (!workOrderType) {
      throw new Error("missing work order type")
    }
    if (!workOrderId) {
      throw new Error("missing workOrderId")
    }
    const result = await getEntityAsync(fetchAuthAsync, `WorkOrderTransport/${workOrderType}`, workOrderId)
    transportEntries.value = sortTimeEntries(result ?? [])
    populateTransportExtensions()
  }

  const newTransportEntryAsync = async (workOrderType, workOrderId, warehouseId, withLocation, startTimeObject) => {
    let location = null

    try {
      if (withLocation) {
        location = await getLocationAsync()
      }
      const te = await insertNewTransportEntryAsync(
        fetchAuthAsync,
        workOrderType,
        workOrderId,
        warehouseId,
        location,
        startTimeObject,
      )
      if (te) {
        await loadTransportEntriesAsync(workOrderType, workOrderId)
        setSuccess("Prevoz začet.", true /* skip scroll */)
        return te.startDateTime
      }
    } catch (err) {
      setError(err)
    }
    return false
  }

  const populateTransportExtensions = () => {
    transportEntries.value = transportEntries.value.map((transportEntry) => {
      ensureTransportEntryExtensions(transportEntry)
      return transportEntry
    })
  }

  const openTransportRecord = computed(() => transportEntries.value.filter((t) => !t.endDateTime).length)

  return {
    loadTransportEntriesAsync,
    newTransportEntryAsync,
    openTransportRecord,
    populateTransportExtensions,
    transportEntries,
  }
}
